var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jitsi-iframe-container",attrs:{"id":"jitsi_meet"}})}
var staticRenderFns = []

export { render, staticRenderFns }